var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Form',{attrs:{"data":_vm.crime,"isSubmitting":_vm.isSubmitting,"isEdit":true},on:{"submit":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }